import { WhatsAppIcon } from '@shared/components/ui';
import { getWhatsAppUrl } from '@shared/utils/whatsappHelpers';
import { useWhatsAppMessage } from '@shared/context/WhatsAppContext';

interface WhatsAppButtonProps {
  /**
   * Clase CSS adicional para el botón
   */
  className?: string;
}

export function WhatsAppButton({ className = '' }: WhatsAppButtonProps = {}) {
  const { message } = useWhatsAppMessage();
  const whatsappUrl = getWhatsAppUrl(message);

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contáctanos por WhatsApp"
      className={`fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-green-500 text-white shadow-lg transition-transform hover:scale-110 hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-400 focus:ring-offset-2 ${className}`}
    >
      <WhatsAppIcon size={28} />
    </a>
  );
}
